import React from "react";

import {cn} from "@isudio/utils";

import {Pagecrumb, type BreadcrumbItems} from "../";

interface HeaderTitleNavProps {
  className?: string;
  title?: string;
  icon?: string;
  image?: string;
  breadCrumbs?: BreadcrumbItems[];
}

const HeaderLeftNav = React.forwardRef<Element, HeaderTitleNavProps>(
  ({
     className = "header-left-nav",
     title,
     icon,
     image,
     breadCrumbs
   }
  ) => {
    return (
      <div
        className={cn(`${className}`, "flex items-center")}>
        <div
          className="shrink-0 w-fit flex items-center justify-center">
          {image ?
            <div
              className="profile-picture w-fit h-fit rounded-full overflow-hidden shadow-[1px_1px_2px_1px_rgba(105,120,127,1)]!">
              <img
                src={image}
                alt={title}
                className="w-10 h-10 object-contain rounded-full border-none"
              />
            </div>
            :
            <i
              className={cn(`fa-duotone fa-light ${icon} text-[32px] text-pale-white`)}/>
          }
        </div>

        <div
          className="flex-col flex-1 pl-3 text-left">
          {title && (
            <span
              tabIndex={-1}
              className="text-md sm:text-lg text-white font-black line-clamp-1"
            >
              {title}
            </span>
          )}

          {breadCrumbs && (
            <Pagecrumb
              breadCrumbs={breadCrumbs}
            />
          )}
        </div>
      </div>
    )
  }
);

HeaderLeftNav.displayName = "HeaderLeftNav"
export {HeaderLeftNav}